import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home.component';
import { PrivacidadComponent } from './pages/privacidad.component';
import { TerminosComponent } from './pages/terminos.component';
import { DevolucionesComponent } from './pages/devoluciones.component';
import { FaqComponent } from './pages/faq.component';
import { LineaComponent } from './pages/linea.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'coleccion/:lineaSlug',
    component: LineaComponent
  },
  {
    path: 'privacidad',
    component: PrivacidadComponent
  },
  {
    path: 'terminos',
    component: TerminosComponent
  },
  {
    path: 'devoluciones',
    component: DevolucionesComponent
  },
  {
    path: 'faq',
    component: FaqComponent
  }
];
